// SD Card Manager — mirrors vortex-api routes/sdCard.ts + services/sdCardService.ts.

/** One node of the tree the Scout uploads. Compact keys: trees can hold thousands of nodes. */
export interface SdNode {
  /** name */
  n: string;
  /** 'd' directory | 'f' file */
  t: 'd' | 'f';
  /** bytes (directories: recursive total) */
  s: number;
  /** modified, epoch ms */
  m: number;
  /** directories: recursive file count */
  f?: number;
  /** directories: children (absent when the scan was truncated here) */
  c?: SdNode[];
}

export interface SdDeviceSummary {
  deviceId: string;
  name: string | null;
  vesselName: string | null;
  serialNumber: string;
  status: string;
  lastSeenAt: string | null;
  volumeId: string | null;
  totalBytes: number | null;
  freeBytes: number | null;
  scannedAt: string | null;
}

export interface SdScanRow {
  deviceId: string;
  volumeId: string | null;
  totalBytes: number | null;
  freeBytes: number | null;
  tree: SdNode | null;
  nodeCount: number | null;
  truncated: boolean;
  scannedAt: string | null;
  receivedAt: string | null;
  interactiveUntil: string | null;
}

export type SdCommandStatus = 'pending' | 'delivered' | 'executing' | 'completed' | 'failed' | 'expired' | 'cancelled';

export interface SdCommand {
  id: string;
  device_id: string;
  type: 'sd.scan' | 'sd.delete' | string;
  payload: { paths?: string[] } & Record<string, unknown>;
  status: SdCommandStatus;
  result: Record<string, unknown> | null;
  created_at: string;
  delivered_at: string | null;
  completed_at: string | null;
}

export interface SdScanResponse {
  scan: SdScanRow | null;
  commands: SdCommand[];
}

/** Top-level folders the platform refuses to delete — keep in step with SD_PROTECTED_ROOTS in the API. */
export const SD_PROTECTED_ROOTS = new Set(['Android', 'System Volume Information', 'LOST.DIR', '.android_secure']);
